<div class="create-advertiser layout-spacing">
    <div class="create-advertiser__main">
        <div class="create-advertiser__form">
            <ntv-card variant="elevated">
                <div class="form-content">
                    <!-- Header -->
                    <div class="form-content__header">
                        <div class="icon-container">
                            <svg width="14" height="14">
                                <use [attr.href]="spritePath + '#' + icons['editPencil']"></use>
                            </svg>
                        </div>
                        <div class="header-info">
                            <h2>Advertisers Information</h2>
                            <p>Fill in the details below to create a new advertiser profile</p>
                        </div>
                    </div>

                    <!-- Profile Image -->
                    <div class="form-content__profile-image">
                        <div class="image-circle">
                            <svg width="40" height="40">
                                <use [attr.href]="spritePath + '#' + icons['profile']"></use>
                            </svg>
                        </div>
                        <span class="label">Profile Image</span>
                        <a class="upload-link">Upload profile image</a>
                    </div>

                    <!-- Form Fields -->
                    <div class="form-content__fields">
                        @for (field of formFields; track field.id; let i = $index) {
                            <div
                                class="field-item"
                                [class.half-width]="i >= 2 && i <= 7"
                                [class.third-width]="i >= 8">
                                <label class="mb-1 block text-sm font-medium text-gray-700">
                                    {{ field.label }}{{ field.required ? '*' : '' }}
                                </label>

                                @if (field.type === 'autocomplete') {
                                    <ntv-autocomplete />
                                } @else {
                                    <ntv-input />
                                }
                            </div>
                        }
                    </div>

                    <!-- Footer / Submit -->
                    <div class="form-content__footer">
                        <ntv-button size="xl"> Save Advertiser Profile </ntv-button>
                    </div>
                </div>
            </ntv-card>
        </div>

        <div class="create-advertiser__map">
            <ntv-card variant="elevated">
                <div class="map">
                    <!-- Map Header -->
                    <div class="map__header">
                        <div class="icon-container">
                            <svg width="14" height="14">
                                <use [attr.href]="spritePath + '#' + icons['editPencil']"></use>
                            </svg>
                        </div>
                        <div class="header-info">
                            <h2>Location Map</h2>
                            <p>Search and filter locations by state</p>
                        </div>
                    </div>

                    <!-- Map Toolbar -->
                    <div class="map__toolbar">
                        <div class="search-field">
                            <ntv-input placeholder="Search location, City, or Address" />
                        </div>
                        <div class="filter-field">
                            <ntv-autocomplete [options]="stateOptions" [config]="stateConfig" />
                        </div>
                    </div>

                    <!-- Actual Map Area -->
                    <div class="map__content">
                        <div class="map-placeholder">
                            <app-google-maps />
                        </div>
                    </div>
                </div>
            </ntv-card>
        </div>
    </div>
</div>
